// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var SetUserAuthResponse_AuthResult;
(function (SetUserAuthResponse_AuthResult) {
    SetUserAuthResponse_AuthResult["OK"] = "OK";
    SetUserAuthResponse_AuthResult["REAUTH_REQUIRED"] = "REAUTH_REQUIRED";
})(SetUserAuthResponse_AuthResult || (SetUserAuthResponse_AuthResult = {}));
export var SetUserAuthResponse_AuthResult_index;
(function (SetUserAuthResponse_AuthResult_index) {
    SetUserAuthResponse_AuthResult_index[SetUserAuthResponse_AuthResult_index["OK"] = 0] = "OK";
    SetUserAuthResponse_AuthResult_index[SetUserAuthResponse_AuthResult_index["REAUTH_REQUIRED"] = 1] = "REAUTH_REQUIRED";
})(SetUserAuthResponse_AuthResult_index || (SetUserAuthResponse_AuthResult_index = {}));
export var UpdateGoogleMappingResponse_UpdateMappingResult;
(function (UpdateGoogleMappingResponse_UpdateMappingResult) {
    UpdateGoogleMappingResponse_UpdateMappingResult["OK"] = "OK";
    UpdateGoogleMappingResponse_UpdateMappingResult["UNAUTHORIZED_USER_FOR_GBL"] = "UNAUTHORIZED_USER_FOR_GBL";
})(UpdateGoogleMappingResponse_UpdateMappingResult || (UpdateGoogleMappingResponse_UpdateMappingResult = {}));
export var UpdateGoogleMappingResponse_UpdateMappingResult_index;
(function (UpdateGoogleMappingResponse_UpdateMappingResult_index) {
    UpdateGoogleMappingResponse_UpdateMappingResult_index[UpdateGoogleMappingResponse_UpdateMappingResult_index["OK"] = 0] = "OK";
    UpdateGoogleMappingResponse_UpdateMappingResult_index[UpdateGoogleMappingResponse_UpdateMappingResult_index["UNAUTHORIZED_USER_FOR_GBL"] = 1] = "UNAUTHORIZED_USER_FOR_GBL";
})(UpdateGoogleMappingResponse_UpdateMappingResult_index || (UpdateGoogleMappingResponse_UpdateMappingResult_index = {}));
export const GoogleReviewsService = {
    GetGoogleReviewDetailById(fn, req) {
        try {
            fm.validateUrlParam(req["encodedReviewId"], "encodedReviewId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/reviews/google-reviews/v1/reviews/${req["encodedReviewId"]}?${fm.renderURLSearchParams(req, ["encodedReviewId"])}`, { method: "GET" });
    },
    SetGoogleAppointmentLink(fn, req) {
        return fn(`/reviews/google-reviews/v1/reviews/appointment-link`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Fetches integration information for locations.
     */
    ListGoogleMappings(fn, req) {
        return fn(`/reviews/google-reviews/v1/reviews/mapping?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Sets a google location as the current Google business for a weave location (i.e. it "maps" a weave location to a Google business location).
     * As part of this process, it also invites the weave reviews service account to manage the location, if necessary.  Refreshes access token.
     */
    SetGoogleMapping(fn, req) {
        return fn(`/reviews/google-reviews/v1/reviews/mapping`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Refreshes access token of Google business location for google user.
     */
    UpdateGoogleMapping(fn, req) {
        return fn(`/reviews/google-reviews/v1/reviews/mapping`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Removes Google integration for location.
     */
    DeleteGoogleMapping(fn, req) {
        return fn(`/reviews/google-reviews/v1/reviews/mapping?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    /**
     * Updates the the Google mapping to show if the location was successful or not in authenticating.
     */
    UpdateReviewsSetupState(fn, req) {
        return fn(`/reviews/google-reviews/v1/reviews/mapping`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Sets Google refresh token after successful authentication of user. If the user id is the configured
     * service account id, it also configures notifications on the account.
     */
    SetUserAuth(fn, req) {
        return fn(`/reviews/google-reviews/v1/user-auth`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Lists Google business locations that a user has access to. This includes matadata about the location.
     * including the name, address, location owners, and location state information.
     */
    ListGoogleLocations(fn, req) {
        return fn(`/reviews/google-reviews/v1/locations?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ExchangeAuth(fn, req) {
        return fn(`/reviews/google-reviews/v1/exchange-auth`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
